import { MutableRefObject, useEffect, useReducer } from "react";
// 常量
import { IBaseDynamicSubTableContext } from "../context/dynamicSubTableContext";
import { STATUS_CREATED, STATUS_CREATED_CODE } from "../../constants/constant";
import { ALL_CHILDREN_KEY, CHILDREN_DATA_KEY, MAIN_FORM_KEY, MAIN_ROW_KEY } from "../interface";
import { FormInstance } from "antd/lib/form";

type DynamicSubTableDispatchType = 'init' | 'changeExpandedRowKeys' | 'change' | 'empty';
export interface IDynamicSubTablePayload {
  /** 当前标记到的末尾行数 */
  flagIndex?: number;
  /** 初始值 */
  dataSource?: any[];
  /** form表单 */
  form?: FormInstance;
  /** 初始时是否默认展开全部 */
  defaultExpandAllRows?: boolean;
  /** 展开的行集合 */
  expandedRowKeys?: string[];
  /** 主表key */
  mainKey?: string;
  /** 子表key */
  childrenKey?: string;
  /** 主表要修改的值 */
  changeMainItem?: any;
  /** 子表要修改的值 */
  changeChildrenItem?: any;
}
export interface IDynamicSubTableAction {
  type: DynamicSubTableDispatchType;
  payload: IDynamicSubTablePayload;
}

const initDynamicSubTableContext: IBaseDynamicSubTableContext = {};

function dynamicSubTableContextAction(
  state: IBaseDynamicSubTableContext,
  action: IDynamicSubTableAction,
) {
  const oldDataSource = state.dataSource;
  const { dataSource, flagIndex, expandedRowKeys, form, defaultExpandAllRows, mainKey, childrenKey, changeMainItem, changeChildrenItem, } = action.payload;
  switch (action.type) {
    /** 初始化数据 */
    case 'init':
      const initDataSource: any[] = [];
      const initExpandedRowKeys: string[] = [];
      dataSource?.forEach((item, index) => {
        const itemKey = `${index}`;
        const newChildren: any[] = (item[CHILDREN_DATA_KEY] ?? []).map?.((child: any, childIndex: number) => ({
          ...child,
          [STATUS_CREATED_CODE]: child[STATUS_CREATED_CODE] ? child[STATUS_CREATED_CODE] : STATUS_CREATED.DEFAULT,
          key: `${index}-${childIndex}`,
        }));
        if (defaultExpandAllRows) {
          initExpandedRowKeys.push(itemKey);
        }
        initDataSource.push({
          ...item,
          key: itemKey,
          [STATUS_CREATED_CODE]: item[STATUS_CREATED_CODE] ? item[STATUS_CREATED_CODE] : STATUS_CREATED.DEFAULT,
          [MAIN_ROW_KEY]: true,
          children: newChildren,
        });
      });
      return {
        form,
        dataSource: initDataSource,
        expandedRowKeys: initExpandedRowKeys,
      };
    /** 修改展开行 */
    case 'changeExpandedRowKeys':
      return {
        ...state,
        expandedRowKeys,
      };
    /** 表单字段值更新 */
    case 'change':
      return {
        ...state,
        dataSource: oldDataSource?.map(item => {
          if (item.key === mainKey) {
            return {
              ...item,
              ...changeMainItem,
              [STATUS_CREATED_CODE]: item[STATUS_CREATED_CODE] === STATUS_CREATED.ADD ? STATUS_CREATED.ADD : STATUS_CREATED.UPDATE,
              [CHILDREN_DATA_KEY]: item?.[CHILDREN_DATA_KEY]?.map?.((childrenItem: any) => {
                if (childrenItem.key === ALL_CHILDREN_KEY) {
                  return {
                    ...childrenItem,
                    ...changeChildrenItem,
                    [STATUS_CREATED_CODE]: childrenItem[STATUS_CREATED_CODE] === STATUS_CREATED.ADD ? STATUS_CREATED.ADD : STATUS_CREATED.UPDATE,
                  };
                }
                if (childrenItem.key === `${mainKey}-${childrenKey}`) {
                  return {
                    ...childrenItem,
                    ...changeChildrenItem,
                    [STATUS_CREATED_CODE]: childrenItem[STATUS_CREATED_CODE] === STATUS_CREATED.ADD ? STATUS_CREATED.ADD : STATUS_CREATED.UPDATE,
                  };
                }
                if (childrenKey === MAIN_FORM_KEY) {
                  return {
                    ...childrenItem,
                    [STATUS_CREATED_CODE]: childrenItem[STATUS_CREATED_CODE] === STATUS_CREATED.ADD ? STATUS_CREATED.ADD : STATUS_CREATED.UPDATE,
                  };
                }
                return childrenItem;
              }),
            };
          }
          return item;
        }),
      };
    /** 清空数据 */
    case 'empty':
      const emptyDataSource: any[] = [];
      oldDataSource?.forEach(item => {
        if (item[STATUS_CREATED_CODE] !== STATUS_CREATED.ADD) {
          emptyDataSource.push({
            ...item,
            [STATUS_CREATED_CODE]: STATUS_CREATED.DELETE,
            children: item.children?.filter?.((v: any) => v[STATUS_CREATED_CODE] !== STATUS_CREATED.ADD)?.map((v: any) => ({
              ...v,
              [STATUS_CREATED_CODE]: STATUS_CREATED.DELETE,
            }))
          });
        }
      });
      return {
        ...state,
        dataSource: emptyDataSource,
        expandedRowKeys: [],
      };
    default:
      return state;
  }
};

function useDynamicSubTableHook(options: {
  /** 标识尾标指针 */
  flagIndex: MutableRefObject<number>;
  /** 数据数组 */
  dataSource?: any[];
  /** form表单对象 */
  form?: FormInstance;
  /** 是否默认展开全部 */
  defaultExpandAllRows?: boolean;
}) {
  const { flagIndex, dataSource, form, defaultExpandAllRows, } = options;
  const [state, dispatch] = useReducer(
    dynamicSubTableContextAction,
    initDynamicSubTableContext,
  );
  useEffect(() => {
    flagIndex.current = dataSource?.length || 0;
    dispatch({ type: 'init', payload: { dataSource, form, defaultExpandAllRows, } });
  }, [dataSource]);
  function dispatchDynamicSubTable(
    type: DynamicSubTableDispatchType,
    payload: IDynamicSubTablePayload = {}
  ) {
    const {  } = payload;
    switch (type) {

      default:
        dispatch({ type, payload, });
        break;
    }
  }

  return {
    ...state,
    dispatchDynamicSubTable,
  };
}

export default useDynamicSubTableHook;
